import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingMessage from '../settings/utils/LoadingMessage';

function ProgressModal({ show, message = 'Saving changes...' }) {
  return (
    <Modal
      show={show}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <LoadingMessage message={message} style={{ margin: 0, padding: 0 }} />
      </Modal.Body>
    </Modal>
  );
}

ProgressModal.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
};

export default ProgressModal;
